module.exports = __webpack_public_path__ + "static/about-1058717bae30f15b1dd5d8dbe9871c50.jpg";